import React from 'react'
import { Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import ResearchDetail from '../../../../shareUI/ResearchDetail/researchDetail'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import PageAction from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import arrayMutators from 'final-form-arrays'
import { GetProjectResultType } from '../../../../../../services/web/types/responseWebServiceTypes'
import useReportedAnonconformance from './useReportedAnonconformance'
import ResearcherDetail from '../../../../shareUI/researcherDetail/researcherDetail'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'
export type ReportedAnonconformanceViewType = ReportedAnonconformanceType &
    ReturnType<typeof useReportedAnonconformance>
const ReportedAnonconformanceView = (props: ReportedAnonconformanceViewType) => {
    const {
        formRef,
        onRefDialog,
        configDialog,
        initialValues,
        projectData,
        initialUploadFile,
        onChangeDocCompletely,
        isCompletely,
        isViewMode,
        checkUseUploadEdit,
        onDirtyChange,
        onSubmitForm,
        onClickBackToSearch,
    } = props
    const manageProjectStore = useManageProjectStore()
    const { documentTopic } = manageProjectStore
    const checkPermission = useCheckPermission()
    const isResearcher = checkPermission.isUserResearcher()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, uploadFile: initialUploadFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                formRef.current = props
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <ResearchDetail dataSource={projectData} />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherDetail dataSource={projectData} />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadDoc
                                    initialData={initialUploadFile}
                                    documentTitleList={documentTopic}
                                    latestDocument={projectData?.latestDocument}
                                    isViewMode={isViewMode && !canUpdateDocument}
                                    isUseUploadfileEdit={checkUseUploadEdit()}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <UploadAdditionalDoc isViewMode={isViewMode && !canUpdateDocument} />
                            </Grid>

                            {!isViewMode || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            props.form.change('submitType', 'draft')
                                            props.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            props.form.change('submitType', 'save')
                                            props.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                        <FormSpy subscription={{ dirty: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type ReportedAnonconformanceType = {
    projectData?: GetProjectResultType
    onSaveComplete?: (status: number, isDraft: boolean) => void
}
const ReportedAnonconformance = (props: ReportedAnonconformanceType) => {
    const reportedAnonconformance = useReportedAnonconformance(props)
    return <ReportedAnonconformanceView {...props} {...reportedAnonconformance} />
}
export default ReportedAnonconformance
